import React from "react";
import { View, StyleSheet, Image, TouchableHighlight} from "react-native";
import colors from "../config/colors";
import Text from "./Text";

function CardListTypeActions({
    title,
    IconComponent,
    onPress,
    backgroundColor = '',
}) {
    return (
        <TouchableHighlight underlayColor={colors.light} onPress={onPress}>
            <View style={backgroundColor === ''? styles.container : 
                        backgroundColor === 'CardEditListaComponentes35y36y37'? styles.containerListaComponente35y36y37 :
                        styles.container1}>
                {IconComponent}
                <View style={backgroundColor === ''? styles.detailsContainer : 
                        backgroundColor === 'CardEditListaComponentes35y36y37'? styles.detailsContainerListaComponente35y36y37 :
                        styles.detailsContainer1}>
                    <Text onPress={onPress}
                    style={backgroundColor === ''? styles.title : 
                    backgroundColor === 'CardEditListaComponentes35y36y37'? styles.titleListaComponente35y36y37 :
                    styles.title1 }
                    >
                     {title}
                    </Text>
                </View>
            </View>
        </TouchableHighlight>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        padding: 3,
        backgroundColor: "white",
        width: "100%"
        //zIndex: 2,
        //position: "relative"
    },
    container1: {
        marginTop: "4%",
        marginLeft: "9%",
        alignItems: "center",
        flexDirection: "row",
        padding: 3,
        backgroundColor: colors.chakra1nar,
        width: "100%",
        zIndex: 1,
        //position: "absolute"
    },
    containerListaComponente35y36y37: { // Para la lista de arreglo imagen componentes 35,36 y 37 de CardEdit.
        marginTop: ".5%",
        //marginLeft: "9%",
        alignItems: "center",
        flexDirection: "row",
        padding: 3,
        backgroundColor: "white",
        //width: "90%",
        zIndex: 1,  
    },
    detailsContainer: {
        marginLeft: 10,
        backgroundColor: "white",
        width: "80%",
        },
    detailsContainer1: {
        marginLeft: 15,
        backgroundColor: colors.chakra1nar,
        width: "80%",
        fontSize: 25,
        fontWeight: "400"
        },
    detailsContainerListaComponente35y36y37: { // Para la lista de arreglo imagen componentes 35,36 y 37 de CardEdit.
        marginLeft: 10,
        backgroundColor: "white",
        width: "80%",
        fontSize: 20,
        fontWeight: "200"
        },
    image: {
        width: 50,
        height: 50,
        borderRadius: 25,
    },
    title: {    // Esto controla el tamaño de la letra en la lista
        fontWeight: "400", 
       width: '70%',
       fontSize: 19,
    },
    title1: {    // Esto controla el tamaño de la letra en la lista
        fontWeight: "400", 
       width: '70%',
       fontSize: 22,
    },
    titleListaComponente35y36y37: {  // Para la lista de arreglo imagen componentes 35,36 y 37 de CardEdit.
        fontWeight: "400", 
        width: '90%',
        fontSize: 19,
    }

});

export default CardListTypeActions;
